import { matchPath } from 'react-router-dom';

/*
 * Rutas del sitio en cada idioma. Español = URLs de siempre; inglés = /en/...
 * Lo usan el router, los links, el botón de idioma y el SEO (hreflang).
 * El script de prerender (scripts/generar-estaticos.js) tiene la misma tabla:
 * si cambiás algo aquí, cambialo allá también.
 */
export const RUTAS = {
  home:     { es: '/',                   en: '/en' },
  todas:    { es: '/AllExperiencia',     en: '/en/experiences' },
  detalle:  { es: '/experiencia/:slug',  en: '/en/experience/:slug' },
  nosotros: { es: '/Quienes_somos',      en: '/en/about-us' },
  resenas:  { es: '/reseñas',            en: '/en/reviews' },
  contacto: { es: '/Contacto',           en: '/en/contact' },
};

// Alias en español que ya existían (siguen funcionando).
export const ALIAS_ES = ['/home'];

export const idiomaValido = (lang) => (lang === 'en' ? 'en' : 'es');

/** Ruta de una página en un idioma. Ej: ruta('detalle', 'en', { slug: 'x' }) → /en/experience/x */
export function ruta(pagina, lang = 'es', params = {}) {
  const patron = (RUTAS[pagina] || RUTAS.home)[idiomaValido(lang)];
  return patron.replace(/:(\w+)/g, (_, k) => encodeURIComponent(params[k] ?? ''));
}

const decodificar = (pathname) => {
  try {
    return decodeURI(pathname);
  } catch {
    return pathname;
  }
};

/** Qué página es una URL: { pagina, lang, params } o null si no es ninguna conocida. */
export function identificarRuta(pathname) {
  const path = decodificar(pathname || '/').replace(/\/+$/, '') || '/';
  if (ALIAS_ES.includes(path)) return { pagina: 'home', lang: 'es', params: {} };
  for (const [pagina, porIdioma] of Object.entries(RUTAS)) {
    for (const lang of ['en', 'es']) {
      const m = matchPath({ path: porIdioma[lang], caseSensitive: false, end: true }, path);
      if (m) return { pagina, lang, params: m.params };
    }
  }
  return null;
}

/** Idioma según la URL: /en/... = inglés, todo lo demás = español. */
export function idiomaDeUrl(pathname) {
  const p = decodificar(pathname || '/').toLowerCase();
  return p === '/en' || p.startsWith('/en/') ? 'en' : 'es';
}

/** La misma página en el otro idioma (para el botón de idioma). */
export function rutaEquivalente(pathname, lang) {
  const actual = identificarRuta(pathname);
  if (!actual) return ruta('home', lang);
  return ruta(actual.pagina, lang, actual.params);
}
